import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import Card, { CardTitle, CardSubtitle, CardDescription, CardFooter } from "./Cards/Card";
import FromNow from "./Dates/FromNow";
import { ColorLabelContainer, ColorLabel } from "UI";
var Task = /*#__PURE__*/function (_Component) {
  function Task(props) {
    var _this;
    _classCallCheck(this, Task);
    _this = _callSuper(this, Task, [props]);
    _defineProperty(_this, "renderAssignmentTaskStatusIcon", function (currentStatus) {
      if (currentStatus == null) return null;
      var statusIcons = [{
        id: 'ASSIGNMENT_TASK_NOT_STARTED',
        url: '/dist/svg/Status_notStarted-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_STARTED',
        url: '/dist/svg/Status_started-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_SUBMITTED',
        url: '/dist/svg/Status_submitted-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_NOT_COMPLETE',
        url: '/dist/svg/Status_notComplete-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_CAN_DEVELOP',
        url: '/dist/svg/Status_canDevelop-ico.svg'
      }];
      var icon = statusIcons.find(function (icon) {
        return icon.id == currentStatus.id;
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginRight: '0.5rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          width: '20px',
          marginRight: '0.3rem'
        },
        src: icon.url,
        alt: "task status"
      }), /*#__PURE__*/React.createElement("div", null, currentStatus.value));
    });
    _this.state = {
      color: _this.props.hasOwnProperty("color") ? _this.props.color : ""
    };
    return _this;
  }
  _inherits(Task, _Component);
  return _createClass(Task, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var status = "";
      if (this.props.status != null) {
        var statusObject = this.props.status.assignmentTypes.find(function (type) {
          return type.id == _this2.props.assignment.assignmentType;
        });
        if (statusObject != null) {
          status = statusObject.value;
        } else {
          if (this.props.assignment.externalId != null) {
            status = "Teams";
          }
        }
      }
      var task = this.props.assignment.tasks != null && this.props.assignment.tasks.length > 0 ? this.props.assignment.tasks[0] : null;
      var currentAssignmentTaskStatus = null;
      if (task != null) {
        currentAssignmentTaskStatus = this.props.status.assignmentTaskStatus.find(function (ats) {
          return ats.id == task.status;
        });
      }
      var id = this.props.assignment.id;
      if (this.props.assignment.externalId != null) {
        id = this.props.assignment.externalId;
      }
      var descriptionMaxLength = 35;
      return /*#__PURE__*/React.createElement(Card, {
        id: id,
        type: "task",
        key: this.props.assignment.id,
        color: this.state.color
      }, /*#__PURE__*/React.createElement("div", {
        className: "task-meta-container"
      }, currentAssignmentTaskStatus != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, this.renderAssignmentTaskStatusIcon(currentAssignmentTaskStatus)) : null, /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, status), this.props.assignment.assessmentId != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, "Bed\xF6md") : null, /*#__PURE__*/React.createElement(FromNow, null, this.props.assignment.dueDate)), /*#__PURE__*/React.createElement(CardSubtitle, null, this.props.assignment.sectionTitle), /*#__PURE__*/React.createElement(CardTitle, null, this.props.assignment.title), this.props.assignment.courses ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, this.props.assignment.courses.map(function (course) {
        var text = course.title;
        text = course.year != null ? text + " " + course.year : text;
        return /*#__PURE__*/React.createElement(ColorLabel, {
          key: course.id,
          tooltip: text,
          color: course.colorCode
        });
      })) : null);
    }
  }]);
}(Component);
export { Task as default };